import { Box, SvgIcon as MUISvgIcon, Stack, Typography } from "@mui/material"
import { Container, ResponsiveImage, IconButton, SvgIcon, Link } from ".."

const FeaturedIn = () => {
  // @TODO replace with actual data once the new CT is created
  const items = [
    {
      icon: {
        variants: [
          {
            url: "https://images.goway.com/dev/featured_in/travel-leisure.svg",
            title: "",
            width: 94,
            style: "default",
            height: 22,
            alt: "",
          },
        ],
      },
    },
    {
      icon: {
        variants: [
          {
            url: "https://images.goway.com/dev/featured_in/afar.svg",
            title: "",
            width: 52,
            style: "default",
            height: 16,
            alt: "",
          },
        ],
      },
    },
    {
      icon: {
        variants: [
          {
            url: "https://images.goway.com/dev/featured_in/forbes.svg",
            title: "",
            width: 71,
            style: "default",
            height: 18,
            alt: "",
          },
        ],
      },
    },
    {
      icon: {
        variants: [
          {
            url: "https://images.goway.com/dev/featured_in/smithsonian.svg",
            title: "",
            width: 116,
            style: "default",
            height: 32,
            alt: "",
          },
        ],
      },
    },
  ]

  return (
    <Container maxWidth={650}>
      <Stack gap={6}>
        <FeaturedInTitle />
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {items.map((item, index) => (
            <Stack key={index} direction="row" alignItems="center">
              <ResponsiveImage
                image={item.icon}
                width={{
                  xs: item.icon.variants[0]?.width,
                  md: item.icon.variants[0]?.width * 1.25,
                }}
              />
            </Stack>
          ))}
        </Box>
      </Stack>
    </Container>
  )
}

export default FeaturedIn

// A sub component for the title of the FeaturedIn component
const FeaturedInTitle = () => {
  return (
    <Typography
      variant="body.md"
      sx={(theme) => ({
        color: theme.palette["neutral.700"].main,
        fontSize: { xs: "14px", md: "15px" },
        lineHeight: { xs: "160%", md: "140%" },
        fontWeight: { xs: 400, md: 500 },
        textAlign: "center",
      })}
    >
      As featured in
    </Typography>
  )
}
